import './Card.scss';
import { Button } from '../Button/Button';

export const Card = ({ title, children, centerTitle, overlay, overlayButtonContent, onOverlayButtonClick }) => {
  return (
    <div className="card">
      {!centerTitle && <div className={`card-title`}>{title}</div>}
      {centerTitle && <div className={`card-title center`}>{title}</div>}
      <div className="content">
        {children}
        {overlay && (
          <div className="overlay">
            <Button onClick={onOverlayButtonClick} text={overlayButtonContent || 'Login or Register'} />
          </div>
        )}
      </div>
    </div>
  );
};
